import React from 'react';
import { Home, Ticket, HelpCircle, User } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function BottomNav() {
  const location = useLocation();
  const pathname = location.pathname;
  // Hide on splash screen
  if (pathname === '/') return null;
  const isActive = (path: string) => pathname === path || pathname.startsWith(path + '/');
  const navItems = [{
    path: '/home',
    icon: Home,
    label: 'হোম'
  }, {
    path: '/my-trips',
    icon: Ticket,
    label: 'আমার ট্রিপ'
  }, {
    path: '/help',
    icon: HelpCircle,
    label: 'সাহায্য'
  }];
  return <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 pb-safe z-50 max-w-[480px] mx-auto" data-id="element-24">
      <div className="flex justify-around items-center h-16" data-id="element-25">
        {navItems.map(item => <Link key={item.path} to={item.path} className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive(item.path) ? 'text-[#006a4e]' : 'text-gray-500'}`} data-id="element-26">
            <item.icon size={24} strokeWidth={isActive(item.path) ? 2.5 : 2} data-id="element-27" />
            <span className="text-xs font-medium font-bengali" data-id="element-28">
              {item.label}
            </span>
          </Link>)}
      </div>
    </nav>;
}